import React, { Component } from 'react';
import splashWebm from 'assets/splash/okletsplaySplash.webm';
import splashSafari from 'assets/splash/okletsplaySplash_res-hevc-safari.mp4';
import { isSafari } from 'react-device-detect';

export function LoadingMessage() {
  return (
    <div className="splash-screen">
      <video autoPlay muted>
        {isSafari ? (
          <source src={splashSafari} type='video/mp4; codecs="hvc1"' />
        ) : (
          <source src={splashWebm} type="video/webm" />
        )}
        <p>Your browser doesn&#39;t support HTML video.</p>
      </video>
    </div>
  );
}

function withSplashScreen(WrappedComponent) {
  // eslint-disable-next-line react/display-name
  return class extends Component {
    constructor(props) {
      super(props);
      this.state = {
        loading: true,
      };
    }

    async componentDidMount() {
      try {
        setTimeout(() => {
          this.setState({
            loading: false,
          });
        }, 3000);
      } catch (err) {
        this.setState({
          loading: false,
        });
      }
    }

    render() {
      const { loading } = this.state;
      if (loading) return LoadingMessage();

      return <WrappedComponent {...this.props} />;
    }
  };
}

export default withSplashScreen;
